import React from "react";
import { useTranslation } from "react-i18next";
import { Check, X, HelpCircle } from "lucide-react";

/**
 * Mini légende des glyphes de vote (✓ vert / ~ orange / ✗ rouge).
 * Affichée sous la rangée de filtres pour aider les nouveaux utilisateurs.
 */
const VoteGlyphLegend: React.FC = () => {
  const { t } = useTranslation("polls");

  return (
    <div
      data-testid="vote-glyph-legend"
      className="flex items-center gap-3 text-[11px] text-muted-foreground"
    >
      <span className="inline-flex items-center gap-1">
        <span className="inline-flex h-4 w-4 items-center justify-center rounded bg-vote-available/20 text-vote-available-foreground">
          <Check className="h-2.5 w-2.5" aria-hidden />
        </span>
        {t("available")}
      </span>
      <span className="inline-flex items-center gap-1">
        <span className="inline-flex h-4 w-4 items-center justify-center rounded bg-vote-maybe/20 text-vote-maybe-foreground">
          <HelpCircle className="h-2.5 w-2.5" aria-hidden />
        </span>
        {t("maybe")}
      </span>
      <span className="inline-flex items-center gap-1">
        <span className="inline-flex h-4 w-4 items-center justify-center rounded bg-vote-unavailable/20 text-vote-unavailable-foreground">
          <X className="h-2.5 w-2.5" aria-hidden />
        </span>
        {t("unavailable")}
      </span>
    </div>
  );
};

export default VoteGlyphLegend;
